import { useEffect, useState } from 'react';
import { profilesApi, useNoticesQuery, useSeeNoticeMutation } from '../profiles/api';
import { useAppDispatch } from '../../store/hooks';
import { STAMP_BOOK_HASH } from '../postage/StampBook';

/** `?verified=1`: back from the "confirm your email" link. Read once, then cleared. */
function takeVerifiedFlag(): boolean {
  const params = new URLSearchParams(window.location.search);
  if (params.get('verified') !== '1') return false;
  params.delete('verified');
  const rest = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + (rest ? `?${rest}` : '') + window.location.hash,
  );
  return true;
}

/**
 * Quiet in-app lines (slice 4): shown once at the top of the app, never a
 * push — "Sam wrote their first letter. You both got a welcome stamp." — and
 * the thank-you after confirming an email.
 */
export function QuietNotices() {
  const dispatch = useAppDispatch();
  const { data: notices } = useNoticesQuery(undefined, { pollingInterval: 5 * 60 * 1000 });
  const [see] = useSeeNoticeMutation();
  const [verified, setVerified] = useState(takeVerifiedFlag);

  useEffect(() => {
    // The confirmation may have just granted a welcome stamp: refresh what shows it.
    if (verified) dispatch(profilesApi.util.invalidateTags(['Me', 'Notices']));
  }, [verified, dispatch]);

  const notice = notices?.[0];
  return (
    <>
      {verified && (
        <div className="offline-banner quiet-notice" role="status">
          <span>Thank you, your email is confirmed.</span>
          <button type="button" className="linkish" onClick={() => setVerified(false)}>
            OK
          </button>
        </div>
      )}
      {notice && (
        <div className="offline-banner quiet-notice" role="status">
          <span>{notice.body}</span>
          {(notice.kind === 'welcome-stamp' || notice.kind === 'stamp-gift') && (
            <button
              type="button"
              className="linkish"
              onClick={() => {
                void see(notice.id);
                window.location.hash = STAMP_BOOK_HASH;
              }}
            >
              See it
            </button>
          )}
          <button type="button" className="linkish" onClick={() => void see(notice.id)}>
            OK
          </button>
        </div>
      )}
    </>
  );
}
